import * as React from 'react';

import FiltersContainerView from '../../views/library/filters-container.view';
import { IPackageListingAppText } from '../../custom/classes/package-listing-text';

import { IPackageListingAppState } from '../../redux-state';
import { connect } from 'react-redux';
import { findDOMNode } from 'react-dom';

import A11yDialog = require('a11y-dialog');

interface StateToProps {
    text: IPackageListingAppText;
    isFixedPackage: boolean;
}

interface ModalControlMethods {
    showFilters: () => void;
    hideFilters: () => void;
}

interface FilterContainerState {
    filterOpen: boolean;
}

export type FiltersContainerProps = StateToProps;
export type FiltersContainerViewProps = FiltersContainerProps & ModalControlMethods & FilterContainerState;



export class FiltersContainerBase extends React.Component<FiltersContainerProps, FilterContainerState> implements ModalControlMethods {
    constructor(props: FiltersContainerProps) {
        super(props);
    }

    showFilters() {
        this.setState({ filterOpen: true})
    }

    hideFilters() {
        this.setState({ filterOpen: false })
    }

    render() {
        return <FiltersContainerView {...this.props} {...this.state} showFilters={this.showFilters.bind(this)} hideFilters={this.hideFilters.bind(this)} />;
    }
}

function mapStateToProps(state: IPackageListingAppState): StateToProps {
    return {
        text: state.packageListingText,
        isFixedPackage: state.packageListingSettings.isFixed
    }
}

export default connect(mapStateToProps)(FiltersContainerBase);